import * as React from 'react';
import styles from './Header.module.css';
import { CSSTransition } from 'react-transition-group';
import MenuGroupComponent from './MenuGroup';
import MenuItemComponent from './MenuItem';
import Tint from './Tint';
export default function Menu(_a) {
    var visible = _a.visible, close = _a.close, contents = _a.contents, title = _a.title;
    var menuRef = React.useRef(null);
    React.useEffect(function () {
        if (visible && menuRef.current)
            menuRef.current.focus();
    }, [visible, menuRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement(CSSTransition, { in: visible, timeout: 300, unmountOnExit: true, classNames: {
                enter: styles.menuEnter,
                enterActive: styles.menuEnterActive,
                exit: styles.menuExit,
                exitActive: styles.menuExitActive
            } },
            React.createElement("div", { ref: menuRef, className: styles.menu, onKeyDown: function (_a) {
                    var key = _a.key;
                    return key === 'Escape' && close();
                }, tabIndex: -1 },
                title && React.createElement("div", { className: styles.title }, title),
                contents.map(function (content, index) {
                    return 'kind' in content ? (React.createElement(MenuItemComponent, { key: index, item: content, close: close })) : (React.createElement(MenuGroupComponent, { key: index, group: content, close: close }));
                }))),
        React.createElement(Tint, { visible: visible, close: close })));
}
